@if (showOverlay()) {
  <div class="auth-overlay" (click)="handleBackdropClick($event)">
    <div class="auth-modal">
      <div class="icon-container">
        <svg class="lock-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
          <path d="M7 11V7a5 5 0 0110 0v4"/>
        </svg>
      </div>

      <h2>{{ STRINGS.EXPIRED_TITLE | translateString }}</h2>
      <p>{{ STRINGS.EXPIRED_DESCRIPTION | translateString }}</p>

      <div class="actions">
        <app-button (buttonClicked)="login()">{{STRINGS.BUTTON_TEXT | translateString}}</app-button>
      </div>

      <p class="hint">
        {{ STRINGS.EXPIRED_HINT | translateString }}
      </p>
    </div>
  </div>
}
